const routeToExplore = ( path: string ) => {
  const topLevelDomainMatch = window.location.hostname.match( /\.[^.]*$/ );
  const topLevelDomain = topLevelDomainMatch ? topLevelDomainMatch[0] : '.com';

  return `${window.location.protocol}//goldbelly${topLevelDomain}${path}`;
};

export default routeToExplore;
